export enum SSEEventType {
  CONNECTION_ESTABLISHED = 'connection_established',
  CUSTOM_DIALOG_PHOTO_GEN = 'custom_dialog_photo_gen',
  CUSTOM_DIALOG_VIDEO_GEN = 'custom_dialog_video_gen',
  HEARTBEAT = 'heartbeat',
  ERROR = 'error',
  AVATAR_GENERATED = 'avatar_gen',
  PERMANENT_CLOSE = 'permanent_close'
}


export interface SSEEventData {
  eventType: SSEEventType;
  status?: string;
  timestamp?: number;
  eroplayVisitorId?: string;
  message?: string;
} 